import Map from 'eemovel-map-library/src/data/google-maps/map';
import { LatLngTuple } from '@googlemaps/polyline-codec';
import { Dispatch } from 'redux';
import Pin from '../../assets/img/pin-svgrepo-com_1.svg';
import { Store } from '../../helpers';
import { addPin } from '../../modules/dashboard/redux/dashboardActions';

type LatLng = {
  lat: number;
  lng: number;
};

export const generatePolygonsOnMap = (
  coordinates: LatLng[] | LatLngTuple[],
  regionColor: string,
  borderColor: string,
  radius?: number
) => {
  const google = window.google;

  const formattedCoordinates = coordinates.map((coordinate) => {
    if ('lat' in coordinate && 'lng' in coordinate) return coordinate;
    return {
      lat: coordinate[0],
      lng: coordinate[1],
    };
  });

  const screenCoordinates = formattedCoordinates[0];

  const newPolygon = new google.maps.Polygon({
    paths: formattedCoordinates,
    strokeColor: borderColor,
    strokeOpacity: 1,
    strokeWeight: 3,
    fillColor: regionColor,
  });

  newPolygon.setMap(Map.map);
  Map.PoligonOnMap = newPolygon;
  Map.map.setCenter(screenCoordinates);
  Map.map.setZoom(14);

  if (formattedCoordinates.length === 1) {
    Map.markCircleOnMap({ center: formattedCoordinates[0] });
    const pin = new google.maps.Marker({
      position: formattedCoordinates[0],
      map: Map.map,
      icon: Pin,
    });
    Store.dispatch(addPin(pin));
  }
};

export const buildCoordinates = () => {
  const isPoligonOnMap = Map.PoligonOnMap && Map.PoligonOnMap.getMap() !== null;
  const isCircleOnMap =
    (Map.markerCircle && Map.markerCircle.getMap() !== null) || false;

  if (isPoligonOnMap) {
    const coordinates =
      isPoligonOnMap &&
      Map.poligonCoordinates().map((coord) => [coord.lat(), coord.lng()]);
    return { coordinates };
  }
  if (isCircleOnMap) {
    // @ts-ignore: Property center not typed correctly
    const markerPosition = isCircleOnMap ? Map.markerCircle.center : undefined;
    const radius = isCircleOnMap ? Map.circleRadius : undefined;
    const coordinates = [markerPosition.lat(), markerPosition.lng()];
    return { coordinates: [coordinates], radius };
  }
};

export const buildCoordinatesReverse = () => {
  const isPoligonOnMap = Map.PoligonOnMap && Map.PoligonOnMap.getMap() !== null;
  const isCircleOnMap =
    (Map.markerCircle && Map.markerCircle.getMap() !== null) || false;

  if (isPoligonOnMap) {
    const coordinates =
      isPoligonOnMap &&
      Map.poligonCoordinates().map((coord) => [coord.lng(), coord.lat()]);
    return { coordinates };
  }
  if (isCircleOnMap) {
    // @ts-ignore: Property center not typed correctly
    const markerPosition = isCircleOnMap ? Map.markerCircle.center : undefined;
    const radius = isCircleOnMap ? Map.circleRadius : undefined;
    const coordinates = [markerPosition.lat(), markerPosition.lng()];
    return { coordinates: [coordinates], radius };
  }
};

export const addIWListener = (
  payload: any,
  id: number,
  buildModal: (dispatch: any) => void
) => {
  return (dispatch: Dispatch<any>) => {
    const map = document.getElementById('mapsToRender');
    const listener = (e: any) => {
      const split = e?.srcElement?.id?.split(',');
      if (split[0] === 'IWButton' && split[1] === id.toString()) {
        dispatch(buildModal(payload));
      }
    };
    if (map) {
      map.removeEventListener('click', listener);
      map.addEventListener('click', listener);
    }
  };
};

export const removeEmptyFromResponse = (responseObject: any) => {
  return Object.fromEntries(
    Object.entries(responseObject).filter(
      ([_, value]) => value !== null || undefined
    )
  );
};
